import { Component, OnInit } from '@angular/core';
import { FeatureFlagService } from '~services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-complete-view-feature-switch',
  template: `
    <ng-container *ngIf="!isV2Enabled">
      <app-complete-view></app-complete-view>
    </ng-container>
    <ng-container *ngIf="isV2Enabled">
      <app-complete-view-v2></app-complete-view-v2>
    </ng-container>
  `,
})
export class CompleteViewFeatureSwitchComponent {
  public isV2Enabled = false;

  constructor(private readonly featureFlagService: FeatureFlagService) {
    this.isV2Enabled = this.featureFlagService.isV2Enabled;
  }
}
